import $ from 'jquery';
import { register } from '../../core/bootstrapper';
import BusinessSpecificFormModel from '../../layout/b2b/businessSpecificFormModel';
import RegisterFormPrivateCustomerView from '../../pages/login/registerFormPrivateCustomerView';
import PasswordQualityView from '../../layout/PasswordQualityView';
import PhoneNumberFormatter from '../../layout/phoneNumberFormatterView';
import LoginView from '../../pages/login/loginView';
import RegisterFormBusinessCustomerView from '../../pages/login/registerFormBusinessCustomerView';
import RegisterFormModel from '../../pages/login/registerFormModel';
import RegisterFormViewModel from '../../pages/login/registerFormViewModel';

register('login', () => {
    var $loginPage = $('#checkout-login');
    var $blockFull = $loginPage.find('#checkout-registration-block-full');
    var viewModel = new RegisterFormViewModel({
        form: new RegisterFormModel(),
        businessForm: new BusinessSpecificFormModel()
    });

    new LoginView({
        el: $loginPage
    });

    $blockFull.find('form').each(function () {
        new PasswordQualityView({
            el: this
        });
    });

    $blockFull.find('[name="telephone"]').each(function () {
        new PhoneNumberFormatter({
            el: this
        });
    });

    if ($blockFull.hasClass('js-registration-b2b')) {
        new RegisterFormBusinessCustomerView({
            el: $blockFull,
            model: viewModel
        });
    } else {
        new RegisterFormPrivateCustomerView({
            el: $blockFull,
            model: viewModel
        });
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/loginBootstrap.js
 **/